module.exports = __webpack_public_path__ + "static/media/mobileicon.a5ea8161.svg";